import "./App.css";
import "./components/PlatinumCard.css";
import ThreeBackground from "./components/ThreeBackground";
// Available card components. Uncomment the import and render line you need.
// import DigitalCard from "./components/DigitalCard";
// import DigitalPlatinumCard from "./components/DigitalPlatinumCard";
import NehaKhanCard from "./components/NehaKhanCard";
// import NehaMishraCard from "./components/NehaMishraCard";
// import PoojaCard from "./components/PoojaCard";
// import RajniCard from "./components/RajniCard";
// import UmaCard from "./components/UmaCard";

// Currently active card components:
// 1. NehaKhanCard - Ms. Neha Khan - 9811612627
// 2. NehaMishraCard - Ms. Neha Mishra - 7007133978
//
// To update names, phone numbers, email, website, address, or social links,
// edit src/components/NehaKhanCard.jsx or src/components/NehaMishraCard.jsx.
// Contact download files are in public/Neha-Khan-Mohindra.vcf
// and public/Neha-Mishra-Mohindra.vcf.

function App() {
  return (
    <div className="App">
      <main className="card-page">
        <ThreeBackground />
        {/* <DigitalCard /> */}
        {/* <DigitalPlatinumCard /> */}
        {/* <PoojaCard /> */}
        {/* <RajniCard /> */}
        {/* <UmaCard /> */}
        <NehaKhanCard />
        {/* <NehaMishraCard /> */}
      </main>
    </div>
  );
}

export default App;
